
import React from 'react';
import { useEffect, useState } from "react";
import { useWS } from '../provider/WS';
import { IMETAMessageType } from '../config/imetahuman';
import { ICOMMANDType } from '../config/icommand';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, Flex, Button, Select, Descriptions, Segmented, Popover, notification, List, Table, ConfigProvider, RadioChangeEvent, Input, Radio, Space } from 'antd';
import { TinyColor } from '@ctrl/tinycolor';
import { SwapLeftOutlined } from '@ant-design/icons';
import some from 'lodash/some';


const { v4: uuidv4 } = require('uuid');
const CLIENT_KEY = "018f4cd8-6214-731c-8499-3b169586ecc5"




export const Client = ({ hidden, ...props }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { message, lastJsonMessage } = useWS();
    const [value, setValue] = useState(0);
    const [clients, setClients] = useState([]);
    const [commandType, setCommandType] = useState();
    const [cmdToCall, setCmdToCall] = useState();

    useEffect(() => {

        const urlSearchString = window.location.search;
        const params = new URLSearchParams(urlSearchString);
        const value = params.get('key');

        if (value !== CLIENT_KEY) {
            navigate("/error")
        }

    }, []);

    useEffect(() => {

        console.log('Nuovo messaggio ricevuto:', lastJsonMessage);
        if (lastJsonMessage != null) {

            if (lastJsonMessage.type === 'cfg') {

                message({
                    type: IMETAMessageType.CFGInfoUpdate,
                    model: 'horizon',
                    message: 'PING',
                    uid: uuidv4(),
                    user: lastJsonMessage.id,
                    clientID: lastJsonMessage.id,
                    clientType: "ADMIN"
                });

                getClients();


            }

            if (lastJsonMessage.type === IMETAMessageType.ADMINResponse && lastJsonMessage.subType === ICOMMANDType.ClientListsResponse) {
                setClients(lastJsonMessage.data);
            }




        }
    }, [lastJsonMessage]);

    const getClients = () => {

        message({
            type: IMETAMessageType.ADMINCommand,
            subType: ICOMMANDType.ClientLists,
            uid: uuidv4(),
            user: lastJsonMessage.id,
            clientID: lastJsonMessage.id,
            clientType: "ADMIN"
        });

    }

    const onChange = (e) => {
        setValue(e.target.value);

    };


    const onSendMessage = (e) => {
        console.log(commandType, value, cmdToCall);

        message({
            type: IMETAMessageType.ADMINCommand,
            subType: commandType,
            command: cmdToCall,
            uid: uuidv4(),
            clientID: value,
            clientType: "ADMIN"
        });



    };


    const handleChange = (value) => {
        console.log(`selected ${value}`);
        setCommandType(value);
    };

    return (
        <>
            <Flex className='MainClient' justify='center' align='top'>
                <Card size="small" className='ClientCard'
                    bordered={true}
                    style={{ width: 700 }}
                    title="Configuration Utility"
                    extra={<a onClick={() => getClients()} href="#">Reload</a>}
                >

                    <Descriptions column={1} bordered={true} layout="horizontal" >
                        <Descriptions.Item label="Client">
                            <Radio.Group onChange={onChange} value={value}>
                                <Space direction="vertical">
                                    <Radio value={0}>None</Radio>
                                    {clients.map((type, i) => (
                                        <Radio value={type.id}>{type.type} ({type.id})</Radio>
                                    ))}

                                </Space>
                            </Radio.Group>
                        </Descriptions.Item>
                        <Descriptions.Item label="Command To Send">
                            <Select
                                defaultValue="none"
                                value={commandType}
                                style={{ width: 220 }}
                                onChange={handleChange}
                                options={[
                                    { value: 'none', label: 'None' },
                                    { value: ICOMMANDType.SetActor, label: 'Set Actor' },
                                    { value: ICOMMANDType.SetBackground, label: 'Set Background' },
                                    { value: ICOMMANDType.RestartMH, label: 'Restart MH' },
                                ]}
                            />
                        </Descriptions.Item>
                        <Descriptions.Item label="Param">
                            <Input placeholder="Value" onChange={evt => setCmdToCall(evt.target.value)} value={cmdToCall} />
                        </Descriptions.Item>

                    </Descriptions>

                    <Flex className='ClientFormSpace'>
                        <Button onClick={onSendMessage} type="primary">Send</Button>
                    </Flex>
                </Card>

                <Card size="small"
                    bordered={true}
                    style={{ width: 400 }}
                    title="Helper"
                >
                    <Descriptions column={1} bordered={true} layout="horizontal" title="Horizon Configuration">
                        <Descriptions.Item label="Actor">2</Descriptions.Item>
                        <Descriptions.Item label="Background">https://metahuman.interlogica.ai/static/media/horizon.png</Descriptions.Item>
                        <Descriptions.Item label="Reload URL">https://horizon.interlogica.ai/?key=018f0b97-409a-7a3a-a7c2-c2ed98e0013b</Descriptions.Item>
                    </Descriptions>

                </Card>


            </Flex>







        </>
    );

}